import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: '$gatewayType',
  initialState: null as string | null,
  reducers: {
    setGatewayType(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
});

export const { setGatewayType } = slice.actions;
export default slice.reducer;
